import { render } from "./AnswerPageTwo.vue?vue&type=template&id=789e5075&scoped=true"
import script from "./AnswerPageTwo.vue?vue&type=script&lang=js"
export * from "./AnswerPageTwo.vue?vue&type=script&lang=js"

import "./AnswerPageTwo.vue?vue&type=style&index=0&id=789e5075&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789e5075"]])

export default __exports__